// Make all the bio cards togglable, so that clicking anywhere on the card expands/collapses the content.
document.addEventListener("DOMContentLoaded", function () {
  const bioCards = document.querySelectorAll(".wp-block-board-bio-card");

  bioCards.forEach((card) => {
    const content = card.querySelector(".bio-card-content");

    if (content) {
      card.addEventListener("click", function () {
        card.classList.toggle("open");
        // Close All the other cards
        bioCards.forEach((otherCard) => {
          if (otherCard !== card) {
            otherCard.classList.remove("open");
          }
        });
      });
    }
  });

  // Store last known heights for each row
  let storedRowHeights = new Map();

  function equalizeBioCardHeights(isResize = false) {
    const cards = document.querySelectorAll(".wp-block-board-bio-card");
    if (!cards.length) return;

    // Group cards by row (top position)
    let rowTops = {};
    cards.forEach(card => {
      const top = card.getBoundingClientRect().top;
      if (!rowTops[top]) rowTops[top] = [];
      rowTops[top].push(card);
    });

    Object.entries(rowTops).forEach(([top, rowCards]) => {
      const rowHasOpen = rowCards.some(card => card.classList.contains("open"));

      // ⛔ If resizing & row has open → restore previous minHeight and skip
      if (isResize && rowHasOpen) {
        const previousHeight = storedRowHeights.get(top);
        if (previousHeight) {
          rowCards.forEach(card => {
            card.style.minHeight = previousHeight + "px";
          });
        }
        return;
      }

      // Normal logic: recalc heights (load OR resize without open)
      let maxHeight = 0;

      // Reset heights before calculating
      rowCards.forEach(card => (card.style.minHeight = "auto"));

      rowCards.forEach(card => {
        const h = card.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      // Apply equal height
      rowCards.forEach(card => {
        card.style.minHeight = maxHeight + "px";
      });

      // Store height for future resize protection
      storedRowHeights.set(top, maxHeight);
    });
  }

  // Initial equalization (store all row heights)
  window.addEventListener("load", () => {
    equalizeBioCardHeights(false);
  });

  // Resize handler
  window.addEventListener("resize", function () {
    clearTimeout(window._bioResizeTimer);
    window._bioResizeTimer = setTimeout(() => {
      equalizeBioCardHeights(true); // resize mode
    }, 150);
  });
});
